// extracted by mini-css-extract-plugin
export default {"base-error":"base_error_base-error__RkIE0","baseError":"base_error_base-error__RkIE0"};